exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-size-1[data-v-b31e61c0]{font-size:1.2rem}", ""]);

// exports
